import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { getS3URL } from "../../../../_helpers";
import moment from "moment/moment";
import { Loading } from "../../../Other/Loading";

const TeacherAdminData = ({ instructor, enquiry = false }) => {
  const [teacherData, setTeacherData] = useState([]);
  const [load, setload] = useState(true);

  const fetch = async () => {
    try {
      let endpoint = instructor ? "instructor/students" : "user/teacher";
      if (enquiry) {
        endpoint = "request/contactus";
      }
      const res = await axiosInstance.get(endpoint);
      setTeacherData(enquiry ? res?.data?.data : res?.data?.data?.data);
    } catch (error) {
      console.error("Error fetching teacher data:", error);
    } finally {
      setload(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  };

  const getAvatarTheme = (name) => {
    const themes = [
      { bg: "#eff6ff", text: "#3b82f6" },
      { bg: "#f5f3ff", text: "#8b5cf6" },
      { bg: "#ecfdf5", text: "#10b981" },
      { bg: "#fffbeb", text: "#f59e0b" },
      { bg: "#fff1f2", text: "#f43f5e" }
    ];
    if (!name) return themes[0];
    const charCode = name.charCodeAt(0) || 0;
    return themes[charCode % themes.length];
  };

  return (
    <div style={{ fontFamily: "'Outfit', sans-serif" }}>
      {load && (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px 8px",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <div className="skeleton circle" style={{ width: "40px", height: "40px", flexShrink: 0 }} />
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                <span className="skeleton" style={{ width: "100px", height: "14px", borderRadius: "4px" }} />
                <span className="skeleton" style={{ width: "140px", height: "10px", borderRadius: "3px" }} />
              </div>
            </div>
          ))}
        </div>
      )}
      {!load && teacherData && teacherData.length > 0 ? (
        teacherData.slice(0, 5).map((item, index) => {
          const name = item?.firstName || item?.name || "Anonymous";
          const theme = getAvatarTheme(name);
          const hasImage = !!item?.profileImage;

          return (
            <div 
              key={index} 
              style={{ 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "space-between",
                padding: "12px 8px",
                borderBottom: "1px solid #f1f5f9",
                borderRadius: "12px",
                transition: "background-color 0.2s"
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f8fafc"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                {hasImage ? (
                  <img
                    src={item.profileImage}
                    alt={name}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid white",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
                    }}
                  />
                ) : (
                  <div style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: theme.bg,
                    color: theme.text,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "14px",
                    border: "2px solid white",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
                  }}>
                    {getInitials(name)}
                  </div>
                )}
                <div style={{ minWidth: 0 }}>
                  <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {name}
                  </p>
                  <p style={{ margin: 0, fontSize: "11px", fontWeight: "600", color: "#64748b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {item?.country || item?.email || "N/A"}
                  </p>
                </div>
              </div>
              <div style={{ textAlign: "right", flexShrink: 0 }}>
                <span style={{ 
                  fontSize: "11px", 
                  fontWeight: "700", 
                  color: "#94a3b8",
                  background: "#f1f5f9",
                  padding: "4px 8px",
                  borderRadius: "12px"
                }}>
                  {item?.createdAt ? moment(item.createdAt).format("MMM DD") : "N/A"}
                </span>
              </div>
            </div>
          );
        })
      ) : (
        !load && (
          <div style={{ textAlign: "center", padding: "20px 0", color: "#94a3b8", fontSize: "13px", fontWeight: "600" }}>
            No data available
          </div>
        )
      )}
    </div>
  );
};

export default TeacherAdminData;
